import { useState } from "react";
import { SLink, SLinkContainer, SLinkIcon, SLinkIconSub, SLinkLabel, SLinkNotification, SLinkSubnav } from "./styles";
import IconComponent from "../../Icons";
import SubMenuComponent from "../subMenuComponent";

function SubMenu({item, baropen, pathname}) {
    const [isSettingsSubMenuOpen, setIsSettingsSubMenuOpen] = useState(false);
    const [subnav, setSubnav] = useState(false);
    const [clickedMenu, setClickedMenu] = useState(false);

    function showSubnav() {
        setSubnav(!subnav);
        setClickedMenu(!clickedMenu)
    }

    return (
        <SLinkContainer key={item.title} $isactive={pathname === item.to} $baropen={baropen}>
            {  item.subNav.length === 0 && (
                    <SLinkSubnav to={item.to} style={!baropen ? { width: 'fit-content' } : {}} $menuopen={clickedMenu} onClick={item.subNav.length > 0 && showSubnav} ><SubMenuComponent  item={item}  baropen={baropen}  subnav={subnav} /></SLinkSubnav>
                )
            }
            { item.subNav.length !== 0 && (
                    <SLink to={item.to} style={!baropen ? { width: 'fit-content' } : {}} $menuopen={clickedMenu} onClick={item.subNav.length > 0 && showSubnav} ><SubMenuComponent  item={item}  baropen={baropen}  subnav={subnav} /></SLink> 
                )
            }

            {subnav && item.subNav && (item.subNav.map((subItem, index) => {
                return (<SubMenu key={index} item={subItem} isSubMenu={true} hasSubMenu={subItem.subNav>0} baropen={baropen} pathname={pathname}  />
                )
            }))}

        </SLinkContainer>
    );
}

export default SubMenu;